"use client";

import React from "react";
import { SectionHeader, ContentCard } from "fansunited-sports-ui";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { getPostImageUrl } from "@/components/ui/PostImage";
import { formatRelativeTime } from "@/utilities/formatting/date";
import type { Post } from "@/payload-types";

interface LatestNewsGridProps {
    articles: Post[];
    title: string;
}

const CARD_STYLES = { typography: { title: "text-lg font-semibold" } } as const;

export const LatestNewsGrid: React.FC<LatestNewsGridProps> = ({ articles, title }) => {
    const nav = useNavigation();

    if (articles.length === 0) {
        return null;
    }

    return (
        <section>
            <SectionHeader
                entity={{
                    name: title,
                    styles: {
                        typography: {
                            name: "text-sm uppercase font-semibold text-foreground",
                        },
                    },
                }}
                styles={{ container: "mb-2" }}
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 lg:gap-4">
                {articles.map((article) => (
                    <ContentCard
                        key={article.id}
                        content={{
                            id: String(article.id),
                            type: article.type === "video" ? "video" : "article",
                            link: nav.post(article),
                            title: article.title,
                            description: article.summary || undefined,
                            image: {
                                url: getPostImageUrl(article, "medium"),
                                alt: article.title,
                            },
                            metadata: { time: formatRelativeTime(article.publishedAt) },
                        }}
                        variant="standard"
                        styles={CARD_STYLES}
                    />
                ))}
            </div>
        </section>
    );
};
